export default "__VITE_ASSET__DuN4pTKi__"